import { Routes } from '@angular/router';

export const settingsRoutes: Routes = [

    {
        path: '',
        loadComponent: () => import('./settings.page').then(m => m.SettingsPage)
    },
    {
        path: 'pest-monitor',
        loadComponent: () => import('./pages/pest-monitor/pest-monitor.page').then(m => m.PestMonitorPage),
    },
    {
        path: 'pest-details',
        loadComponent: () => import('./pages/pest-detail/pest-detail.page').then(m => m.PestDetailPage),
    },
    {
        path: 'pest-upload',
        loadComponent: () => import('./pages/pest-upload/pest-upload.page').then(m => m.PestUploadPage),
    },
    {
        path: 'soil-nutrient',
        loadComponent: () => import('./pages/soil-nutrient/soil-nutrient.page').then(m => m.SoilNutrientPage),
    },
    {
        path: 'crop-insurance',
        loadComponent: () => import('./pages/crop-insurance/crop-insurance.page').then(m => m.CropInsurancePage),
    },
    {
        path: 'insurance-details',
        loadComponent: () => import('./pages/insurance-details/insurance-details.page').then(m => m.InsuranceDetailsPage),
    },
    {
        path: 'insurance-page',
        loadComponent: () => import('./pages/insurance-page/insurance-page.page').then(m => m.InsurancePagePage),
    },
    {
        path: 'where-to-insure',
        loadComponent: () => import('./pages/where-to-insure/where-to-insure.page').then(m => m.WhereToInsurePage),
    },
    {
        path: 'premium-crop',
        loadComponent: () => import('./pages/premium-crop/premium-crop.page').then(m => m.PremiumCropPage),
    },
    {
        path: 'organic-products',
        // loadComponent: () => import('./pages/organic-products/organic-products.page').then(m => m.OrganicProductsPage),
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/organic-products/organic-products.page').then(m => m.OrganicProductsPage),
            },
            {
                path: 'organic-farmers',
                loadComponent: () => import('./pages/organic-products/organic-farmer/organic-farmer.page').then(m => m.OrganicFarmerPage)
            },
            {
                path: 'organic-district',
                loadComponent: () => import('./pages/organic-products/organic-farmer-district/organic-farmer-district.page').then(m => m.OrganicFarmerDistrictPage)
            },
            {
                path: 'organic-farmers-list',
                loadComponent: () => import('./pages/organic-products/organic-farmer-list/organic-farmer-list.page').then(m => m.OrganicFarmerListPage)
            }
        ]
    },
    {
        path: 'farmer-officer-contact',
        loadComponent: () => import('./pages/farmer-officer-contact/farmer-officer-contact.page').then(m => (m.FarmerOfficerContactPage))
    },
    {
        path: 'fpo-products',
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/fpo-products/fpo-products.page').then(m => m.FpoProductsPage)
            },
            {
                path: 'recomended/:crop',
                loadComponent: () => import('./pages/fpo-products/recomended/recomended.page').then(m => m.RecomendedPage)
            },
            {
                path: 'single-fpo/:crop',
                loadComponent: () => import('./pages/fpo-products/single-fpo/single-fpo.page').then(m => m.SingleFpoPage)
            }
        ]
    },
    {
        path: 'bio-fertilizers',

        children: [{
            path: '',
            loadComponent: () => import('./pages/fertilizers/fertilizers.page').then(m => m.FertilizersPage)
        },
        {
            path: 'stock-position',
            loadComponent: () => import('./pages/fertilizers/fert-stock-pos/fert-stock-pos.page').then(m => m.FertStockPosPage)
        },
        {
            path: 'fert-price',
            loadComponent: () => import('./pages/fertilizers/fert-price/fert-price.page').then(m => m.FertPricePage)
        },
        {
            path: 'bio-fertilizer',
            loadComponent: () => import('./pages/fertilizers/bio-fertilizer/bio-fertilizer.page').then(m => m.BioFertilizerPage)
        },
        ]
    },
    {
        path: 'seed-stock',
        children: [
            {
                path: '',
                loadComponent: () => import('./pages/seed-stock/seed-stock.page').then(m => m.SeedStockPage)
            },
            {
                path: 'single-stock',
                loadComponent: () => import('./pages/seed-stock/single-stock/single-stock.page').then(m => m.SingleStockPage)
            }
        ]
    },
    {
        path: 'tree-seedling',
        loadComponent: () => import('./pages/tree-seedling/tree-seedling.page').then(m => m.TreeSeedlingPage)
    },
    {
        path: 'sericulture',
        loadComponent: () => import('./pages/sericulture/sericulture.page').then(m => m.SericulturePage)
    },
    {
        path: 'veterinary',
        loadComponent: () => import('./pages/veterinary/veterinary.page').then(m => m.VeterinaryPage)
    },
    {
        path: 'uzhavar',
        loadComponent: () => import('./pages/uzhavar/uzhavar.page').then(m => m.UzhavarPage)
    },
    {
        path: 'gallery',
        loadComponent: () => import('./pages/gallery/gallery.page').then(m => m.GalleryPage)
    },
    {
        path: 'agri-machinery',
        loadComponent: () => import('./pages/agri-machinery/agri-machinery.page').then(m => m.AgriMachineryPage)
    },
    {
        path: 'training-demo',
        loadComponent: () => import('./pages/training-demo/training-demo.page').then(m => m.TrainingDemoPage)
    },

]